import { makeAutoObservable, runInAction } from 'mobx';
import {
  IContractPayment,
  IContractPaymentParams,
} from 'src/@types/Choqorak/MainTables/Finance/ContractPayment';

import agent from 'src/api/agent';
export default class ContractPaymentStore {
  openDialog = false;

  ContractPaymentRegistry = new Map<number, IContractPayment>();

  editMode = false; //When click on edit button

  selectedContractPayment: IContractPayment | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get ContractPaymentList() {
    return Array.from(this.ContractPaymentRegistry.values());
  }

  setContractPaymentList = (ContractPayment: IContractPayment) => {
    this.ContractPaymentRegistry.set(ContractPayment.id!, ContractPayment);
  };

  //Pagination
  loadContractPayment = async (params: IContractPaymentParams) => {
    // this.ContractPaymentRegistry.clear();
    try {
      const result = await agent.ContractPayment.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractPaymentList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ContractPaymentSearch = async (params: IContractPaymentParams) => {
    //this.ContractPaymentRegistry.clear();
    this.loadContractPayment(params);
  };

  getContractPaymentFromRegistry = (id: number) => {
    let ContractPayment = this.ContractPaymentRegistry.get(id);
    if (ContractPayment) {
      this.editMode = true;
      this.selectedContractPayment = ContractPayment;
    }
  };

  clearSelectedContractPayment = () => {
    this.editMode = false;
    this.selectedContractPayment = undefined;
  };

  deleteContractPayment = async (id: number, remark?: string) => {
  
      await agent.ContractPayment.delete(id, remark!);
      runInAction(() => {
        this.ContractPaymentRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createContractPayment = async (ContractPayment: IContractPayment) => {

      await agent.ContractPayment.create(ContractPayment);
      runInAction(() => {
        this.loadContractPayment({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedContractPayment();
      });
   
  };

  updateContractPayment = async (ContractPayment: IContractPayment) => {
   
      await agent.ContractPayment.update(ContractPayment);

      runInAction(() => {
        this.loadContractPayment({ pageIndex: 0, pageSize: 5 });
        this.ContractPaymentRegistry.delete(ContractPayment.id!);
        this.ContractPaymentRegistry.set(ContractPayment.id!, ContractPayment);
        this.clearSelectedContractPayment();
      });
   
  };
}
